import html5 from 'assets/techIcons/html.png';
import css3 from 'assets/techIcons/css.png';
import js from 'assets/techIcons/js.png';
import jquery from 'assets/techIcons/jquery.png';
import three from 'assets/techIcons/three.png';
import bootstrap from 'assets/techIcons/bootstrap.png';
import blazor from 'assets/techIcons/blazor.png';
import razor from 'assets/techIcons/razor.png';
import react from 'assets/techIcons/react.png';
import node from 'assets/techIcons/node.png';
import java from 'assets/techIcons/java.png';
import spring from 'assets/techIcons/spring.png';
import cSharp from 'assets/techIcons/cSharp.png';
import dotNet from 'assets/techIcons/dotnet.png';
import efCore from 'assets/techIcons/ef.png';
import postgre from 'assets/techIcons/postgre.png';
import sqlLite from 'assets/techIcons/sqlLite.png';
import mySql from 'assets/techIcons/mysql.png';
import php from 'assets/techIcons/php.png';
import symfony from 'assets/techIcons/symfony_4.png';
import android from 'assets/techIcons/android.png';
import c from 'assets/techIcons/c.png';
import cPlus from 'assets/techIcons/cplus.png';
import assembly from 'assets/techIcons/assembly.png';
import freeRtos from 'assets/techIcons/freeRtos.png';
import arduino from 'assets/techIcons/arduino.png';
import cypress from 'assets/techIcons/cypress-logo.png';
import gtest from 'assets/techIcons/gtest-logo.png';
import jest from 'assets/techIcons/jest-logo.png';
import junit from 'assets/techIcons/JUnit-5-logo.png';
import reactNative from 'assets/techIcons/react-native-logo.png';

export const frontEndIcons = [
  {
    imageSrc: html5,
    text: 'HTML 5',
  },
  {
    imageSrc: css3,
    text: 'CSS 3',
  },
  {
    imageSrc: js,
    text: 'Java Script',
  },
  {
    imageSrc: jquery,
    text: 'jQuery',
  },
  {
    imageSrc: three,
    text: 'ThreeJS',
  },
  {
    imageSrc: bootstrap,
    text: 'BootStrap',
  },
  {
    imageSrc: blazor,
    text: 'Blazor',
  },
  {
    imageSrc: razor,
    text: 'Razor pages',
  },
  {
    imageSrc: react,
    text: 'React',
  },
  {
    imageSrc: node,
    text: 'NodeJS',
  },
];

export const backEndIcons = [
  {
    imageSrc: java,
    text: 'Java',
  },
  {
    imageSrc: spring,
    text: 'Spring',
  },
  {
    imageSrc: cSharp,
    text: 'C#',
  },
  {
    imageSrc: dotNet,
    text: 'ASP .NET',
  },
  {
    imageSrc: efCore,
    text: 'EF Core',
  },
  {
    imageSrc: postgre,
    text: 'Postgre SQL',
  },
  {
    imageSrc: sqlLite,
    text: 'SQL Lite',
  },
  {
    imageSrc: mySql,
    text: 'MySQL',
  },
  {
    imageSrc: php,
    text: 'PHP',
  },
  {
    imageSrc: symfony,
    text: 'Symfony',
  },
];

export const mobileIcons = [
  {
    imageSrc: android,
    text: 'Android',
  },
  {
    imageSrc: reactNative,
    text: 'React Native',
  },
];

export const embeddedIcons = [
  {
    imageSrc: c,
    text: 'C',
  },
  {
    imageSrc: cPlus,
    text: 'C++',
  },
  {
    imageSrc: assembly,
    text: 'Assembly',
  },
  {
    imageSrc: freeRtos,
    text: 'FreeRTOS',
  },
  {
    imageSrc: arduino,
    text: 'Arduino',
  },
];

export const testingIcons = [
  {
    imageSrc: cypress,
    text: 'Cypress',
  },
  {
    imageSrc: jest,
    text: 'Jest',
  },
  {
    imageSrc: junit,
    text: 'JUnit 5',
  },
  {
    imageSrc: gtest,
    text: 'GTest',
  },
];
